const FUZZY_SEARCH_ITEMS = [
  {
    title: `1. Provide your IC and supported documents
    2. Go to Application Tab and fill in.
    3. Fill in your loan amount and submit!`,
    synonyms: ['How do i apply for loan'],
  },
  {
    title: `Benefits of Unit Trusts
    1) Professional management
    2) Diversification
    3) Economies of scale`,
  },
  {
    title: `Eligibility of Unit Trusts
    1) Make a one-time investment on a fund and take immediate advantage of the underlying market.
    2) Make regular investments from as low as RM100* a month and even out market risks in the long run.
    3) A systematic investment programme that spreads out your one-time unit trust investment amount over a 6-month or 12-month period.`,
  },
  {
    title: `Benefits of Premier Account
    1) Easily manage funds with e-Statement.
    2) Insures eligible deposits for up to RM250,000 per depositor.
    3) Enable to create joint account with 2 or more individuals.`,
  },
  {
    title: `Eligibility of Premier Account 
    1a) Individuals aged 18 years old and above
    1b) Malaysian, Permanent Residents and Non-residents

    Documents Required
    2a) IC
    2b) Letter (existing account holder with at least 12 months with CI Bank / statements form another banks)
    2c) Minimum Initial Deposit - RM3,000`,
  },
  {
    title: 'I\'m glad to help you.',
  },
  {
    title: 'Thank you for reaching out, can I have your contact to follow up?',
    synonyms: ['can you give me your number', 'hi there', 'vip', 'vvip', 'vvvip'],
  },
  {
    title: 'How may I help you?',
    synonyms: ['hello', 'hi there', 'hey', 'sorry'],
  },
  {
    title: 'Pleasure to serve you.',
  },
]

export default FUZZY_SEARCH_ITEMS



// WEBPACK FOOTER //
// ./src/InteractionFolder/fuzzySearchItems.js